import { forwardRef } from 'react';
import Description from './Description';
import VenueLocationSection from './VenueLocationSection';
import Layout from './Layout';
import OrganizeBy from './OrganizeBy';
import ScheduleSection from './ScheduleSection';
import ShareEvent from './ShareEvent';
import TagsSection from './TagsSection';
import TermsAndFaqs from './TermsAndFaqs';

const MoreDetailSection = forwardRef(({ previewData }, ref) => {
    const isSingleDayEventWithSlots =
        previewData?.event_type === 'single_day' &&
        previewData?.schedules[0]?.slots &&
        previewData?.schedules[0]?.slots.length > 0;

    const isMultiDateEvent = previewData?.event_type === 'multi_day';

    return (
        <div className="event-preview-more-detail-section" ref={ref}>
            <div className="event-preview-flexbox-container">
                <div className="event-preview-left-flex-box">
                    <Description description={previewData?.description} />
                    <TermsAndFaqs
                        shmoozTerms={previewData?.shmoozTerms}
                        eventOrganizerTerms={previewData?.terms_and_conditions}
                        shmoozFaqs={previewData?.shmoozFaqs}
                        eventOrganizerFaqs={previewData?.faq}
                    />
                </div>

                <div className="event-preview-right-flex-box">
                    {(isSingleDayEventWithSlots || isMultiDateEvent) && (
                        <ScheduleSection previewData={previewData} />
                    )}

                    {!previewData?.online_event && (
                        <VenueLocationSection
                            venueName={previewData?.venue}
                            address={previewData?.address}
                            latitude={previewData?.latitude}
                            longitude={previewData?.longitude}
                        />
                    )}

                    <TagsSection
                        subcategories={previewData?.subcategories || []}
                        formats={previewData?.formats || []}
                        tags={previewData?.tags || []}
                    />

                    {previewData?.event_layout && <Layout layoutUrl={previewData?.event_layout} />}

                    <OrganizeBy organizerName={previewData?.creator_name} />

                    <ShareEvent />
                </div>
            </div>
        </div>
    );
});

export default MoreDetailSection;
